export enum CacheKeys {
  ANONYMOUS_APP_TOKEN = "ANONYMOUS_APP_TOKEN",
  ANONYMOUS_ORDER_COMPLETED = "ANONYMOUS_ORDER_COMPLETED",
  ANONYMOUS_ORDER_ID = "ANONYMOUS_ORDER_ID",
  CORRELATION_ID = "CORRELATION_ID",
  EMAIL_NORMALISED = "EMAIL_NORMALISED",
  EVA_TOKEN = "EVA_TOKEN",
  GUEST_SIGN_UP_DATA = "GUEST_SIGN_UP_DATA",
  GUEST_TRACKING_TOKEN = "GUEST_TRACKING_TOKEN",
  GUEST_RETURN_THANK_YOU_STORAGE_KEY = "GUEST_RETURN_THANK_YOU_STORAGE_KEY",
  RECENT_ORDERS = "RECENT_ORDERS",
  REMEMBERME_DISABLED = "REMEMBERME_DISABLED",
  SIGNAL_R_TOKEN = "SIGNAL_R_TOKEN",
  CART_PRODUCTS_NUMBER = "CART_PRODUCTS_NUMBER",
}
